"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgTimesCircle = function SvgTimesCircle(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M707.2 700.8c-6.4 6.4-16 9.6-22.4 9.6-9.6 0-16-3.2-22.4-9.6L515.2 553.6 368 700.8c-6.4 6.4-12.8 9.6-22.4 9.6-9.6 0-16-3.2-22.4-9.6-12.8-9.6-12.8-28.8 0-41.6L470.4 512 323.2 364.8c-12.8-9.6-12.8-28.8 0-41.6 9.6-12.8 28.8-12.8 41.6 0L512 470.4l147.2-147.2c9.6-12.8 28.8-12.8 41.6 0 12.8 9.6 12.8 28.8 0 41.6L553.6 512l153.6 147.2c12.8 9.6 12.8 28.8 0 41.6zM1024 512c0 281.6-230.4 512-512 512S0 793.6 0 512 230.4 0 512 0s512 230.4 512 512zm-60.8 0c0-249.6-201.6-451.2-451.2-451.2S60.8 262.4 60.8 512 262.4 963.2 512 963.2 963.2 761.6 963.2 512z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgTimesCircle, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;